<template>
          <transition-group name="list" tag="div" class="columns is-multiline is-mobile">
          <div class="column is-full-mobile-custom is-half-mobile is-one-third-tablet is-one-quarter-desktop is-one-quarter-widescreen is-one-quarter-fullhd list-item" v-for="(i, index) in content" :key="index + 1">
            <router-link :to="'/projekte/' + i.content.seo.niceUrl">
              <div class="card is-shadowless" 
              :style="'padding-top:100%;background-image: url(' + assetsBaseUrl + (i.content.thumbnail.length ? i.content.thumbnail[0].path : i.content.seo.image.path) + ');'">
              <div class="card-content tile-text">
                <p class="title is-6 is-size-7-mobile">{{ i.content.headline }}</p>
              </div>
            </div>
            </router-link>
          </div>
          </transition-group>
</template>

<script>
export default {
  props: ['content'],
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
  },
  computed: {
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  }
}
</script>

<style scoped>

@media screen and (max-width: 500px) {
.is-full-mobile-custom {
    width: 100% !important;
}
}

.card-content .title {
  color: white;
  text-shadow: 1px 1px 2px black;
}

.card {
  border-radius: 15px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.tile-text {
   position:  absolute;
   bottom: 0;
   left: 0;
}

.list-move { transition: all 600ms ease-in-out 50ms }

.list-enter-active { transition: all 300ms ease-out }

.list-leave-active {
    transition: all 200ms ease-in;
    position: absolute;
    z-index: 0;
  }
  .list-enter,
  .list-leave-to { opacity: 0 }
  .list-enter { transform: scale(0.9) }

</style>


// WEBPACK FOOTER //
// src/components/shared/ProjectsOverview.vue